module.exports = __webpack_public_path__ + "static/media/icon-social-user-reach.c0b9331f.svg";